<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">

                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                                <div style="min-height: 500px;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <app-sub-header title="Create Post card"></app-sub-header>



                                            <div class="form-group">
                                                <!-- <label for="comment">Alert Title</label> -->
                                                <textarea class="form-control" formControlName="name"
                                                    placeholder="Title for Postcard" rows="2"
                                                    [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                                                   </textarea>
                                                <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.name.errors.required">
                                                        {{errorMessage}}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <!-- <label for="comment">Description</label> -->
                                                <textarea maxlength="100" class="form-control"
                                                    formControlName="description" placeholder="Description" rows="5"
                                                    [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
                                                <div style="text-align: right;" class="margin-b">
                                                    <p style="margin-bottom: -1rem;" class="small error">
                                                        {{f.description.value?.length || 0}}/100</p>
                                                </div>
                                                <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                                    <div style="text-align: right;"
                                                        *ngIf="f.description.errors.required">{{errorMessage}}</div>
                                                </div>



                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <br>
                                <button type="submit" class="btn btn-lg btn-block main-backgroundcolor color" style="margin-top: -200px;">Create</button>
                            </form>
                        </div>
                    </div>
                </div>


            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>